module.exports = __webpack_public_path__ + "img/herwig-langanger.ba23996a.jpg";